import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { WrapHeader } from 'styles/GlobalStyle'
import { Tabs } from 'components'
import { initialPage } from 'keys/pagination'
import { CreateAssessmentsContext } from './CreateAssessmentsContext'
import { createAssessmentsHooks } from '.'
import { CreateAssessmentsStyles } from './Style'
import { createAssessmentsHooks as selectAssessmentsHooks } from './Assessments'

const CreateAssessments = () => {
    const contextValues = useContext(CreateAssessmentsContext)
    const { learningGroups, setSelectedAssessmentDefs, selectedAssessmentDefs, setAssessmentFilters, assessmentFilters, currentTab, setCurrentTab, setPage, status, showBattery, customFilters } = contextValues
    const [statusFilters, setStatusFilters] = useState(status)

    const { headerFilters } = useSelector(state => state.header)

    const createAssessments = selectAssessmentsHooks.useBatteryAllocationBtn()
    const tabs = createAssessmentsHooks.useTabs()
    const yearFilter = createAssessmentsHooks.useYearFilter()

    useEffect(() => {
        return (() => {
            setPage(initialPage)
        })
    }, [statusFilters])

    useEffect(() => {
        setPage(initialPage)
    }, [headerFilters])

    const handleTab = (index) => {
        setCurrentTab(index)
    }

    const TabComponent = tabs[currentTab]?.Component

    return (
        <CreateAssessmentsStyles>
            <WrapHeader withTabs>
                <Tabs defaultValue={currentTab} tabs={tabs} handleTab={handleTab} />
                <yearFilter.component {...yearFilter} />
            </WrapHeader>
            {/* reander current tab component */}
            <TabComponent
                {...contextValues}
                createAssessments={createAssessments}
            />
        </CreateAssessmentsStyles>
    )
}

export default CreateAssessments